import { Component, inject, Input, OnDestroy, OnInit } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { PageMetaTags } from "../models";

@Component({
  selector: 'd4c-meta',
  template: ''
})
export class MetaComponent implements OnInit, OnDestroy {
  private meta = inject(Meta);
  private title = inject(Title);

  @Input() metaTags?: PageMetaTags;

  ngOnInit(): void {
    if (this.metaTags?.title) {
      this.title.setTitle('Design 4 Circularity | ' + this.metaTags.title);
      this.meta.addTag({
        name: 'title',
        content: this.metaTags?.title
      })
    } else this.title.setTitle('Design 4 Circularity');

    if (this.metaTags?.description)
      this.meta.addTag({
        name: 'description',
        content: this.metaTags?.description
      })
  }

  ngOnDestroy(): void {
    this.meta.removeTag('name="title"');
    this.meta.removeTag('name="description"');
  }

}
